import React from "react";
import Banner from "../components/utilities/Banner";
// components
import VideoHeader from "../components/Media/VideoHeader";
import Event from "../components/Media/Event";
import NewsCom from "../components/Media/NewsCom";
function Media() {
  return (
    <div className="container ">
      <Banner />
      <VideoHeader />
      <Event />
      <NewsCom></NewsCom>
    </div>
  );
}

export default Media;
